export enum ExternalLinkTypes {
  'Microsoft' = 'microsoft',
  'Google' = 'google',
}

export enum Mode {
  Light = 'light',
  Dark = 'dark',
}
